module.exports = __webpack_public_path__ + "static/SalesProcess_high_res-2b5bce717811fed2add9c215c0567bb7.jpg";